import React, { Component } from 'react'

export class PrivacyPolicy extends Component {
  render() {
    return (
  <div
  
  style={{padding:40}}
  
  >
   <h1><b> Privacy Policy</b> </h1>
<br/>

Last Updated on 22nd January 2024 
<br/>
<br/>
GenZvision (“us”, “we”, or “our”) operates the GenZvision.com / website (the “Service”). This page is to inform you of our policies regarding the collection, use, and disclosure of personal data when you use our Service and the choices you have associated with that data. 
<br/>
<br/>

We utilize your information to give and improve the Service given by us. By utilizing the Service, you consent to the gathering and utilization of data as for this strategy. Except if generally characterized, terms utilized in this Privacy Policy have indistinguishable implications from our Terms and Conditions, open from GenZvision.com /. 
<br/>
<br/>

<h3><b>Definitions</b> </h3>

<h3><b>Service</b></h3> 


Service is GenZvision.com / website which is operated by Stuffenzy LLP. 

<br/>
<br/>

<h3><b>Personal Data</b></h3> 


Individual Data implies information about a living person who can be distinguished from those information (or from those and other data either in our ownership or prone to come into our ownership). 
<br/>
<br/>


<h3><b>Usage Data</b></h3> 



Utilization Data will be information gathered consequently either created by the utilization of the Service or from the Service foundation itself (for instance, the span of a page visit). 
<br/>
<br/>

<h3><b>Cookies</b></h3> 

Cookies are small pieces of data stored on your device (computer or mobile device). 
<br/>
<br/>

<h3><b>Data Controller</b></h3> 

Information Controller implies the characteristic or legitimate individual who (either alone or together or in the same way as different people) decides the reasons for which and the way where any close to home data are, or are to be, handled. With the end goal of this Privacy Policy, we are a Data Controller of your Personal Data. 
<br/>
<br/>
Data Processors (or Service Providers) 
<br/>
<br/>

Data Processor (or Service Provider) means any natural or legal person who processes the data on behalf of the Data Controller. We may use the services of various Service Providers in order to process your data more effectively. 
<br/>
<br/>

Data Subject (or User) 
<br/>
<br/>

Data Subject is any living individual who is using our Service and is the subject of Personal Data. 
<br/>
<br/>

Information Collection And Use 
<br/>
<br/>

We collect several information for various purposes to provide and improve our Service to you. 
<br/>
<br/>

<h3><b>TYPES OF DATA COLLECTED</b></h3> 

Personal Data 
<br/>
<br/>

While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you (“Personal Data”). Personally identifiable information may include, but is not limited to: 
<br/>
<br/>

– Email address 
<br/>
<br/>

– First name and last name 
<br/>
<br/>

– Phone number 
<br/>
<br/>

– Address, State, Province, ZIP/Postal code, City 
<br/>
<br/>

– Cookies and Usage Data 
<br/>
<br/>

We may use your Personal Data to contact you with newsletters, marketing or promotional materials and other information that may be of interest to you. You may opt out of receiving any, or all, of these communications from us by following the unsubscribe link or instructions provided in any email we send. 
<br/>
<br/>

Usage Data 

We may likewise gather data on how the Service is gotten and utilized (“Usage Data”). This Usage Data may incorporate data, for example, your PC’s Internet Protocol address (for example IP address), program type, program form, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, extraordinary gadget identifiers and other symptomatic information. 
<br/>
<br/>

Tracking Cookies Data
<br/>
<br/>


We use cookies and comparative following advances to follow the action on our Service and hold certain data.  
<br/>
<br/>

Cookies are records with a limited quantity of information that may incorporate an unknown exceptional identifier.   
<br/>
<br/>

Cookies are sent to your program from a site and placed on your gadget. Following advancements additionally utilized are signals, labels, and contents to gather and track data and to improve and examine our Service.   
<br/>
<br/>

You can teach your program to reject all threats or to notify when a threat is being sent. Notwithstanding, on the off chance that you don’t acknowledge cookies, you will be unable to utilize a few parts of our Service.  
<br/>
<br/>

Examples of Cookies we use: 
<br/>
<br/>

– Session Cookies. We use Session Cookies to operate our Service. 
<br/>
<br/>

– Preference Cookies. We use Preference Cookies to remember your preferences and various settings. 
<br/>
<br/>

– Security Cookies. We use Security Cookies for security purposes.  
<br/>
<br/>

Use of Data 
<br/>
<br/>

GenZvision uses the collected data for various purposes: 
<br/>
<br/>

– To provide and maintain our Service 
<br/>
<br/>

– To notify you about changes to our Service 
<br/>
<br/>

– To allow you to participate in interactive features of our Service when you choose to do so 
<br/>
<br/>

– To provide customer support 
<br/>
<br/>

– To gather analysis or valuable information so that we can improve our Service 
<br/>
<br/>

– To monitor the usage of our Service 
<br/>
<br/>

– To detect, prevent and address technical issues 
<br/>
<br/>

– To provide you with news, special offers, and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless you have opted not to receive such information  
<br/>
<br/>

Legal Basis for Processing Personal Data Under General Data Protection Regulation (GDPR). 
<br/>
<br/>

We may process your Personal Data because: 
<br/>
<br/>

– We need to perform a contract with you 
<br/>
<br/>

– You have given us permission to do so 
<br/>
<br/>

– The processing is in our legitimate interests and it’s not overridden by your rights 
<br/>
<br/>

– For payment processing purposes 
<br/>
<br/>

– To comply with the law  

<br/>
<br/>
Retention of Data 

<br/>
<br/>
GenZvision will hold your Personal Data just for whatever length of time that is important for the reasons set out in this Privacy Policy. We will hold and utilize your Personal Data to the degree important to consent to our lawful commitments (for instance, on the off chance that we are required to hold your information to follow material laws), resolve debates, and authorize our lawful understandings and strategies.   

<br/>
<br/>
GenZvision will likewise hold Usage Data for inward investigation purposes. Use Data is commonly held for a shorter time frame, aside from when this information is utilized to reinforce the security or to improve the usefulness of our Service, or we are legitimately committed to hold this information for longer timespans.  

<br/>
<br/>
Transfer Of Data 

<br/>
<br/>
Your information, including Personal Data, may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from your jurisdiction.   

<br/>
<br/>
Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.  
<br/>
<br/>

GenZvision.com will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of your data and other personal information.   
<br/>
<br/>

Security Of Data 
<br/>
<br/>

The security of your information is critical to us, however remember that no strategy for transmission over the Internet, or technique for electronic capacity is 100% secure. While we endeavor to utilize industrially worthy intends to ensure your Personal Data, we can’t ensure its supreme security.   
<br/>
<br/>

In the event that you wish to be educated what Personal Data we hold about you and on the off chance that you need it to be expelled from our frameworks, it would be ideal if you get in touch with us.   
<br/>
<br/>

In specific conditions, you have the accompanying information insurance rights:   
<br/>
<br/>

The privilege to access, update or erase the data we have on you. At whatever point made conceivably, you can access, update or solicit erasure of your Personal Data legitimately inside your record settings area. In the event that you can’t play out these activities yourself if it’s not too much trouble get in touch with us to help you.  
<br/>
<br/>

The privilege to protest. You reserve the privilege to the item to our preparing of your Personal Data.  
<br/>
<br/>

The privilege of limitation. You reserve the privilege to demand that we limit the preparation of your own data.  
<br/>
<br/>

The privilege to information versatility. You reserve the option to be given a duplicate of the data we have on you in an organized, machine-comprehensible, and generally utilized arrangement.  

<br/>
<br/>
The privilege to pull back assent. You additionally reserve the option to pull back your assent whenever where GenZvision depended on your agreement to process your own data.   
<br/>
<br/>

If you don’t mind note that we may request that you check your personality before reacting to such asks.  
<br/>
<br/>

You reserve the privilege to grumble to a Data Protection Authority about our accumulation and utilization of your Personal Data. For more data, if you don’t mind contact your nearby information assurance specialist in the European Economic Area (EEA).Service Providers 

<br/>
<br/>
We may employ third-party companies and individuals to facilitate our Service (“Service Providers”), to provide the Service on our behalf, to perform Service-related services, or to assist us in analyzing how our Service is used. 
<br/>
<br/>

These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose. 

<br/>
<br/>
ANALYTICS 

<br/>
<br/>
We may utilize outsider Service Providers to screen and break down the utilization of our Service.  
<br/>
<br/>

Google Analytics  
<br/>
<br/>

Google Analytics is a web examination administration offered by Google that tracks and reports site traffic. Google utilizes the information gathered to track and screen the utilization of our Service. This information is imparted to other Google administrations. Google may utilize the gathered information to contextualize and customize the advertisements of its own publicizing system.  
<br/>
<br/>

You can quit having made your movement on the Service accessible to Google Analytics by introducing the Google Analytics quit program add-on. The extra counteracts the Google Analytics JavaScript (ga.js, analytics.js, and dc.js) from offering data to Google Analytics about visits movement. 

<br/>
<br/>
For more information on the privacy practices of Google, please visit the Google Privacy Terms web page: http://www.google.com/intl/en/policies/privacy/ 
<br/>
<br/>

BEHAVIORAL REMARKETING 

<br/>
<br/>
Facebook Inc. uses remarketing services to advertise on third party websites to you after you visited our Service. We and our third-party vendors use cookies to inform, optimize and serve ads based on your past visits to our Service. 

<br/>
<br/>
Google AdWords 

<br/>
<br/>
Google AdWords remarketing service is provided by Google Inc. 

<br/>
<br/>
You can opt-out of Google Analytics for Display Advertising and customize the Google Display Network ads by visiting the Google Ads Settings page: http://www.google.com/settings/ads 

<br/>
<br/>
Google also recommends installing the Google Analytics Opt-out Browser Add-on – https://tools.google.com/dlpage/gaoptout – for your web browser. Google Analytics Opt-out Browser Add-on provides visitors with the ability to prevent their data from being collected and used by Google Analytics. 

<br/>
<br/>
For more information on the privacy practices of Google, please visit the Google Privacy Terms web page: http://www.google.com/intl/en/policies/privacy/ 

<br/>
<br/>
<h3><b>Facebook</b></h3> 

Facebook remarketing service is provided by Facebook Inc. 
<br/>
<br/>

You can learn more about interest-based advertising from Facebook by visiting this page: https://www.facebook.com/help/164968693837950 
<br/>
<br/>

To opt-out from Facebook’s interest-based ads follow these instructions from Facebook: https://www.facebook.com/help/568137493302217 
<br/>
<br/>

Facebook adheres to the Self-Regulatory Principles for Online Behavioral Advertising established by the Digital Advertising Alliance. You can also opt-out from Facebook and other participating companies through the Digital Advertising Alliance in the USA http://www.aboutads.info/choices/, the Digital Advertising Alliance of Canada in Canada http://youradchoices.ca/ or the European Interactive Digital Advertising Alliance in Europe http://www.youronlinechoices.eu/, or opt-out using your mobile device settings. 
<br/>
<br/>

For more information on the privacy practices of Facebook, please visit Facebook’s Data Policy: https://www.facebook.com/privacy/explanation 
<br/>
<br/>

<h3><b>PAYMENTS</b></h3> 

We may provide paid products and/or services within the Service. In that case, we use third-party services for payment processing (e.g. payment processors). 
<br/>
<br/>

We will not store or collect your payment card details. That information is provided directly to our third-party payment processors whose use of your personal information is governed by their Privacy Policy. These payment processors adhere to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, Mastercard, American Express, and Discover. PCI-DSS requirements help ensure the secure handling of payment information. 
<br/>
<br/>

The payment processors we work with are: 
<br/>
<br/>

<h3><b>PhonePe</b></h3> 

Their Privacy Policy can be viewed at 
<br/>
<br/>

<a href='https://phonepe.com/privacy-policy/'>https://phonepe.com/privacy-policy/</a> 
<br/>
<br/>

<h3><b> Links To Other Sites</b></h3> 

Our Service may contain links to other sites that are not operated by us. If you click on a third-party link, you will be directed to that third party’s site. We strongly advise you to review the Privacy Policy of every site you visit. 
<br/>
<br/>

 We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services. 

<br/>
<br/>
 Children’s Privacy 

<br/>
<br/>
We do not knowingly collect personally identifiable information from anyone under the age of 18. If you are a parent or guardian and you are aware that your Children has provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from children without verification of parental consent, we take steps to remove that information from our servers. 

<br/>
<br/>
 Changes To This Privacy Policy 
<br/>
<br/>

We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. 

<br/>
<br/>
We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective and update the “effective date” at the top of this Privacy Policy.  
<br/>
<br/>

You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page. 

<br/>
<br/>
<h3><b>Contact Us</b></h3> 

If you have any questions about this Privacy Policy, please contact us by email:<a href='mailto:genzvisionuser@gmail.com'> genzvisionuser@gmail.com</a>& <a href='mailto:support@stuffenzy.com'>support@stuffenzy.com </a> 
<br/>
<br/>
<br/>
<br/>
<br/>
<br/>
<br/>
 
  </div>
    )
  }
}

export default PrivacyPolicy